class ProductFeaturesList extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    const list = this.querySelector('.key-features-pdp ul');
    const toggle = this.querySelector('.product-features__toggle');
    if (!(list instanceof HTMLUListElement) || !(toggle instanceof HTMLButtonElement)) return;

    this.dataset.initialized = 'true';

    const hasHiddenFeatures = list.querySelector('li:nth-child(6)') !== null;
    toggle.hidden = !hasHiddenFeatures;
    if (!hasHiddenFeatures) return;

    toggle.addEventListener('click', () => {
      const expanded = this.toggleAttribute('expanded');
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded
        ? toggle.dataset.collapseLabel || 'See Less -'
        : toggle.dataset.expandLabel || 'See More +';
    });
  }
}

if (!customElements.get('product-features-list')) {
  customElements.define('product-features-list', ProductFeaturesList);
}
